'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useContext, useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';

import cx from 'clsx';

import ButtonCTA from 'components/ui/ButtonCTA';
import carouselContext from 'components/ui/CarouselProvider/CarouselContext';

import { getColor } from 'utils';

import OverflowCarouselNav from './OverflowCarouselNav';
import OverflowCarouselText from './OverflowCarouselText';
import OverflowSlide from './OverflowSlide';

import styles from './BlockOverflowCarousel.module.scss';

const OverflowCarousel = ({ firstBlock }) => {
    const ref = useRef(null);
    const [isInView, setIsInView] = useState(firstBlock || false);

    const context = useContext(carouselContext);

    const firstSlideChangeOccurred = context.firstSlideChangeOccurred;
    const isInitialPaint = !firstSlideChangeOccurred && firstBlock;

    const intersection = useIntersection(ref, {
        root: null,
        rootMargin: '0px',
        threshold: 0,
    });

    useEffect(() => {
        if (!firstBlock && intersection?.isIntersecting) {
            setIsInView(true);
        }
    }, [intersection, firstBlock]);

    const activeSlide = context.slides?.[context.activeIndex];
    const backgroundColor = activeSlide?.backgroundColor;
    const isOverflowSlide =
        activeSlide?.__typename === 'BlockOverflowCarouselOverflowSlide';

    return (
        <section
            ref={ref}
            className={cx(styles.root, {
                [styles.isInView]: isInView,
                [styles.isInitialPaint]: isInitialPaint,
                [styles.isOverflowSlide]: isOverflowSlide,
            })}
            style={{
                '--background-color': backgroundColor
                    ? getColor(backgroundColor)
                    : undefined,
            }}
        >
            <div className={styles.inner}>
                <div className={styles.slides}>
                    {context.slides?.map((slide, i) => (
                        <OverflowSlide
                            key={i}
                            {...slide}
                            isActive={context.activeIndex === i}
                            isPrev={context.prevIndex === i}
                            isInitialPaint={isInitialPaint || false}
                            hasImagePriority={
                                (context.activeIndex === 0 && firstBlock) ||
                                false
                            }
                        />
                    ))}
                </div>
                <div className={styles.content}>
                    <div className={styles.text}>
                        <OverflowCarouselText isInitialPaint={isInitialPaint} />
                    </div>
                    <div className={styles.buttons}>
                        {context.slides?.map((slide, i) =>
                            slide.cta ? (
                                <div key={i} className={styles.button}>
                                    <div
                                        className={cx(styles.buttonTransition, {
                                            [styles.isActive]:
                                                context.activeIndex === i,
                                        })}
                                    >
                                        <ButtonCTA
                                            {...slide.cta}
                                            style="filled-blue-cream"
                                            tabIndex={
                                                context.activeIndex === i
                                                    ? 0
                                                    : -1
                                            }
                                        />
                                    </div>
                                </div>
                            ) : null
                        )}
                    </div>
                    <div className={styles.nav}>
                        <OverflowCarouselNav isInView={isInView} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OverflowCarousel;
